// dev-requests-conversa — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Conversa com o robô": "Conversación con el robot",
    "Resumo do robô": "Resumen del robot",
    "Robô": "Robot",
};

export default catalogo;
